import { GlobalDocumentsState, InitialGlobalDocumentsState } from '../state/globalDocuments.state';
import { GlobalDocumentsAction, GlobalDocumentsActions } from '../actions/globalDocuments.action';

export function globalDocumentsReducers(
  state = InitialGlobalDocumentsState,
  action: GlobalDocumentsAction
): GlobalDocumentsState {
  switch (action.type) {
    case GlobalDocumentsActions.GetAllGlobalDocuments: {
      return {
        ...state,
        getAllGlobalDocumentsInProgress: true,
      };
    }
    case GlobalDocumentsActions.GetAllGlobalDocumentsSuccess: {
      return {
        ...state,
        getAllGlobalDocumentsSuccess: action.payload,
        getAllGlobalDocumentsError: null,
        getAllGlobalDocumentsInProgress: false,
      };
    }
    case GlobalDocumentsActions.GetAllGlobalDocumentsError: {
      return {
        ...state,
        getAllGlobalDocumentsError: action.payload,
        getAllGlobalDocumentsSuccess: null,
        getAllGlobalDocumentsInProgress: false,
      };
    }
    case GlobalDocumentsActions.CloneToCompany: {
      return {
        ...state,
        cloneToCompanyInProgress: true,
        cloneToCompanySuccess: null,
        cloneToCompanyError: null,
      };
    }
    case GlobalDocumentsActions.CloneToCompanySuccess: {
      return {
        ...state,
        cloneToCompanySuccess: action.payload,
        cloneToCompanyError: null,
        cloneToCompanyInProgress: false,
      };
    }
    case GlobalDocumentsActions.CloneToCompanyError: {
      return {
        ...state,
        cloneToCompanyError: action.payload,
        cloneToCompanySuccess: null,
        cloneToCompanyInProgress: false,
      };
    }
    case GlobalDocumentsActions.ResetCloneToCompanyStatus: {
      return {
        ...state,
        cloneToCompanySuccess: null,
        cloneToCompanyError: null,
        cloneToCompanyInProgress: false,
      };
    }
    case GlobalDocumentsActions.AddGlobalDocument: {
      return {
        ...state,
        addGlobalDocumentInProgress: true,
        addGlobalDocumentSuccess: null,
        addGlobalDocumentError: null,
      };
    }
    case GlobalDocumentsActions.AddGlobalDocumentSuccess: {
      return {
        ...state,
        addGlobalDocumentSuccess: action.payload,
        addGlobalDocumentError: null,
        addGlobalDocumentInProgress: false,
      };
    }
    case GlobalDocumentsActions.AddGlobalDocumentError: {
      return {
        ...state,
        addGlobalDocumentError: action.payload,
        addGlobalDocumentSuccess: null,
        addGlobalDocumentInProgress: false,
      };
    }
    case GlobalDocumentsActions.ResetAddGlobalDocumentStatus: {
      return {
        ...state,
        addGlobalDocumentSuccess: null,
        addGlobalDocumentError: null,
        addGlobalDocumentInProgress: false,
      };
    }
    case GlobalDocumentsActions.GetGlobalDocumentTypes: {
      return {
        ...state,
        getDocumentTypesInProgress: true,
      };
    }
    case GlobalDocumentsActions.GetGlobalDocumentTypesSuccess: {
      return {
        ...state,
        getDocumentTypesSuccess: action.payload,
        getDocumentTypesError: null,
        getDocumentTypesInProgress: false,
      };
    }
    case GlobalDocumentsActions.GetGlobalDocumentTypesError: {
      return {
        ...state,
        getDocumentTypesError: action.payload,
        getDocumentTypesSuccess: null,
        getDocumentTypesInProgress: false,
      };
    }
    case GlobalDocumentsActions.EditGlobalDocument: {
      return {
        ...state,
        editGlobalDocumentInProgress: true,
        editGlobalDocumentSuccess: null,
        editGlobalDocumentError: null,
      };
    }
    case GlobalDocumentsActions.EditGlobalDocumentSuccess: {
      return {
        ...state,
        editGlobalDocumentSuccess: action.payload,
        editGlobalDocumentError: null,
        editGlobalDocumentInProgress: false,
      };
    }
    case GlobalDocumentsActions.EditGlobalDocumentError: {
      return {
        ...state,
        editGlobalDocumentError: action.payload,
        editGlobalDocumentSuccess: null,
        editGlobalDocumentInProgress: false,
      };
    }
    case GlobalDocumentsActions.ResetEditGlobalDocumentStatus: {
      return {
        ...state,
        editGlobalDocumentSuccess: null,
        editGlobalDocumentError: null,
        editGlobalDocumentInProgress: false,
      };
    }
    case GlobalDocumentsActions.DeleteGlobalDocument: {
      return {
        ...state,
        deleteGlobalDocumentInProgress: true,
        deleteGlobalDocumentSuccess: null,
        deleteGlobalDocumentError: null,
      };
    }
    case GlobalDocumentsActions.DeleteGlobalDocumentSuccess: {
      return {
        ...state,
        deleteGlobalDocumentSuccess: action.payload,
        deleteGlobalDocumentError: null,
        deleteGlobalDocumentInProgress: false,
      };
    }
    case GlobalDocumentsActions.DeleteGlobalDocumentError: {
      return {
        ...state,
        deleteGlobalDocumentError: action.payload,
        deleteGlobalDocumentSuccess: null,
        deleteGlobalDocumentInProgress: false,
      };
    }
    case GlobalDocumentsActions.ResetDeleteGlobalDocumentStatus: {
      return {
        ...state,
        deleteGlobalDocumentSuccess: null,
        deleteGlobalDocumentError: null,
        deleteGlobalDocumentInProgress: false,
      };
    }
    default: {
      return state;
    }
  }
}
